import { render, staticRenderFns } from "./carReview.vue?vue&type=template&id=04423f22&scoped=true"
import script from "./carReview.vue?vue&type=script&lang=js"
export * from "./carReview.vue?vue&type=script&lang=js"
import style0 from "./carReview.vue?vue&type=style&index=0&id=04423f22&prod&lang=scss"
import style1 from "./carReview.vue?vue&type=style&index=1&id=04423f22&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04423f22",
  null
  
)

export default component.exports